import React from 'react'
import { observer } from 'mobx-react-lite'
import { navStore } from '../nav/Nav'
import { RightMenu } from '../nav/RightMenu'
import { Params } from '../../packages/blueprint-components/src/useTableHooks'

interface FloatingToolbarProps {
    onSwitchToClassic?: () => void
    activeLabel?: string
    params?: Params
}

export const FloatingToolbar = observer(
    ({ onSwitchToClassic, activeLabel = 'New editor', params = {} }: FloatingToolbarProps) => {
        const bannerH = navStore.bannerHeight

        return (
            <div
                className="fixed right-0 z-30 h-12 flex items-center gap-1 px-2 group"
                style={{ top: bannerH }}
            >
                <div className="flex items-center gap-1 rounded-xl border border-transparent bg-transparent shadow-sm transition-all duration-150 group-hover:border-[#DBE2E8] group-hover:bg-white group-hover:shadow-md px-1.5 py-1">
                    {onSwitchToClassic && (
                        <div className="flex items-center gap-1 bg-[#F1F3F6] rounded-lg p-0.5">
                            <button
                                type="button"
                                className="px-3 h-7 rounded-md text-[12px] font-[500] transition bg-white text-[#0E2947] shadow-sm ring-1 ring-[#DBE2E8] cursor-default"
                            >
                                {activeLabel}
                            </button>
                            <button
                                type="button"
                                onClick={onSwitchToClassic}
                                className="px-3 h-7 rounded-md text-[12px] font-[500] transition text-[#7289A3] hover:text-[#0E2947]"
                            >
                                Classic
                            </button>
                        </div>
                    )}
                    <RightMenu params={params} />
                </div>
            </div>
        )
    },
)
